import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';
import qs from 'qs';

export enum EnumStatus {
    NORMAL = 'NORMAL',
    INACTIVE = 'INACTIVE'
}

export enum EnumRoles {
    ADMIN = 'ADMIN',
    OPERATOR = 'OPERATOR'
}

export interface IUserDetail {
    name: string;
    account: string;
    type: string;
    status: string;
    createTime: string;
    id?: number;
}
export interface IUserListParam {
    name?: string;
    status?: string;
    pageNo: number;
    pageSize: number;
}
export interface IUserList {
    list: IUserDetail[];
    pageNum: number;
    pageSize: number;
    total: number;
}
export interface IUserInfoEdit {
    account?: string;
    password?: string;
    name?: string;
    type?: string;
    id?: number;
    status?: string;
}
export interface IUserPassword {
    password: string;
    id?: number;
}
class UserService extends HTTP {
    config: AxiosRequestConfig = {
        baseURL: this.config.baseURL + '/common-ucenter-server/api'
    };
    async me() {
        const response = await this.get('/b/users/me');
        return response;
    }

    //查询用户列表
    async getUserList(userListQuery: IUserListParam) {
        if (userListQuery.name === '') {
            delete userListQuery.name;
        }
        return await this.get(`/b/users`, {
            params: userListQuery,
            paramsSerializer: (params: any) => {
                return qs.stringify(params, { allowDots: true });
            }
        });
    }

    //新增用户
    async createUserInfo(param: IUserInfoEdit) {
        return await this.post(`/b/users/add`, param);
    }

    //修改用户信息
    async updateUserInfo(param: IUserInfoEdit) {
        return await this.post(`/b/users/update`, param);
    }

    async modifyPassword(param: IUserPassword) {
        return await this.post(`/b/users/update`, param);
    }
}
export default new UserService();
